<main class="container">
    <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">
        @if (hasPermissions()) {
        <div class="row" *ngIf="submittedRequests.length === 0">
            <div class="col col-12">
                <h1>update non chevron permissions</h1>

                <form class="branded" *ngIf="!isCompleted">
                    <fieldset class="pb-3">
                        <legend class="form-row p-2 pl-3 mb-4 bg-dark-blue text-white">
                            <p><strong>application</strong></p>
                        </legend>
                        <app-search [ownedApps]="true" [searchPermissions]="false"
                            (appSelected)="clientAppSelected($event)" [tenantType]="applicationRegistrationType"
                            *ngIf="clientApp === undefined">
                        </app-search>

                        <display-form [displayObject]="displayClientApp"
                            *ngIf="displayClientApp !== undefined"></display-form>
                    </fieldset>
                </form>

                <fieldset class="pb-4" *ngIf="displayClientApp !== undefined">
                    <legend class="form-row p-2 pl-3 mb-4 bg-dark-blue text-white">
                        <p><strong>permissions</strong></p>
                    </legend>
                    <div *ngIf="!isLoading && requestablePermissionsDataSource.data.length == 0">
                        no permissions were found
                    </div>
                    <div *ngIf="isLoading">
                        <div class="row justify-content-center col-sm-12">
                            <p>searching for permissions...</p>
                        </div>
                        <div class="row justify-content-center col-sm-12">
                            <mat-spinner></mat-spinner>
                        </div>
                    </div>
                    <div>
                        <form class="branded">
                            <filter-input (onKeyUp)="doFilterPermissions($event)"
                                *ngIf="!isLoading && requestablePermissionsDataSource.data.length > 0"></filter-input>

                            <download-button [class]="'float-right'" toolTip="export data" *ngIf="!isLoading"
                                (click)="exportToCsv()">
                            </download-button>

                            <table id="nonChevronPermissions" style="height: fit-content;"
                                [hidden]="isLoading || requestablePermissionsDataSource.data.length == 0" mat-table
                                [dataSource]="requestablePermissionsDataSource" matSort matSortActive="permissionValue"
                                matSortDirection="asc" aria-describedby="non chevron permissions">

                                <caption>permissions</caption>

                                <ng-container matColumnDef="select">
                                    <th mat-header-cell *matHeaderCellDef>
                                        <input type="checkbox" (change)="$event ? masterTogglePermissions() : null"
                                            [checked]="selection.hasValue() && isAllSelected()"
                                            [indeterminate]="selection.hasValue() && !isAllSelected()" />
                                    </th>
                                    <td mat-cell *matCellDef="let row">
                                        <div class="checkbox-cell">
                                            <input MatCheckbox class="non-chevron-checkbox" type="checkbox"
                                                name="formcheckbox" (click)="$event.stopPropagation()"
                                                (change)="selectPermission(row)" [checked]="isSelected(row)" />
                                        </div>

                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="permissionType">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> permission type</th>
                                    <td mat-cell *matCellDef="let permission">{{ permission.permissionType }}</td>
                                </ng-container>

                                <ng-container matColumnDef="permissionValue">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> permission value </th>
                                    <td mat-cell *matCellDef="let permission">{{ permission.permissionValue }}</td>
                                </ng-container>

                                <ng-container matColumnDef="owners">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> owners </th>
                                    <td mat-cell *matCellDef="let permission">
                                        <mat-chip-set>
                                            @for (owner of permission.owners; track owner;) {
                                            <mat-chip style="background-color:#0066B2">
                                                {{ owner.lastName }}, {{ owner.firstName }}
                                            </mat-chip>
                                            }
                                        </mat-chip-set>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="lastApprovedDate">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> preapproval change date </th>
                                    <td mat-cell *matCellDef="let permission">
                                        <span *ngIf="permission.lastApproved" style="display:inline-block;">
                                            {{ permission.lastApproved | date:'MM/dd/yyyy' }}
                                        </span>
                                        @if (permission.preapproved && permission.lastApproved && DateHelpers.daysAgoFromToday(permission.lastApproved)
                                        >= 365) {
                                        <mat-icon class="material-symbols-outlined"
                                            style="vertical-align: bottom; color: #e21836;">
                                            dangerous
                                        </mat-icon>
                                        }
                                        @else if(permission.preapproved && permission.lastApproved &&
                                        DateHelpers.daysAgoFromToday(permission.lastApproved) >= 335) {
                                        <mat-icon class="material-symbols-outlined"
                                            style="vertical-align: bottom; color: #faab18;">
                                            warning
                                        </mat-icon>
                                        }
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="lastApprovedBy">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> preapproval changed by </th>
                                    <!-- only print last approved by if it exists -->
                                    <td mat-cell *matCellDef="let permission">
                                        @if (permission.lastApprovedBy) {
                                        <span>
                                            {{ permission.lastApprovedBy.displayName }}
                                        </span>
                                        }
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="preapproved">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> preapproved </th>
                                    <td mat-cell *matCellDef="let permission">
                                        {{ permission.preapproved | formatText }}
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="selectPermissionsDisplayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: selectPermissionsDisplayedColumns;"
                                    style="height: 100%;"></tr>

                            </table>
                            <mat-paginator *ngIf="!isLoading" [length]="requestablePermissionsDataSource.data.length"
                                [pageSizeOptions]="[10, 20, 30, 40]" showFirstLastButtons></mat-paginator>
                        </form>
                    </div>
                </fieldset>


                <display-http-error [message]="getPermissionsErrorMessage" [errors]="[]"></display-http-error>

                @if(selection.selected.length > 0)
                {
                <legend class="form-row p-2 pl-3 mb-4 bg-dark-blue text-white">
                    <p><strong>selected permissions</strong></p>
                </legend>

                <div>
                    <div class="center-content">
                        <p><strong>all owners</strong></p>
                    </div>
                    <div class="center-content">
                        <mat-chip-set>
                            @for (owner of allSelectedOwners; track owner;) {
                            <mat-chip style="background-color:#0066B2">
                                <mat-label style="color:white;">{{ owner.lastName }}, {{ owner.firstName }}</mat-label>
                                <button (click)="bulkRemoveOwner(owner.id)" matChipRemove>
                                    <mat-icon style="color:white;">cancel</mat-icon>
                                </button>
                            </mat-chip>
                            }
                            <mat-chip (click)="searchAddPrimaryUser(selection.selected)"
                                style="background-color:#0066B2">
                                <mat-icon class="center-content" style="cursor:pointer;">add</mat-icon>
                            </mat-chip>
                        </mat-chip-set>
                    </div>
                </div>
                <form class="branded">
                    <table id="selectedNonChevronPermissions" [hidden]="isLoading || selection.selected.length == 0"
                        mat-table [dataSource]="selection.selected" aria-describedby="selected non chevron permissions">

                        <caption>permissions</caption>

                        <ng-container matColumnDef="permissionType">
                            <th mat-header-cell *matHeaderCellDef> permission type</th>
                            <td mat-cell *matCellDef="let permission">{{ permission.permissionType }}</td>
                        </ng-container>

                        <ng-container matColumnDef="permissionValue">
                            <th mat-header-cell *matHeaderCellDef> permission value </th>
                            <td mat-cell *matCellDef="let permission">{{ permission.permissionValue }}</td>
                        </ng-container>

                        <ng-container matColumnDef="owners">
                            <th mat-header-cell *matHeaderCellDef> owners </th>
                            <td mat-cell *matCellDef="let permission">
                                <mat-chip-set>
                                    @for (owner of permission.owners; track owner;) {
                                    <mat-chip style="background-color:#0066B2">
                                        <mat-label style="color:white;">{{ owner.lastName }}, {{ owner.firstName
                                            }}</mat-label>
                                        <button (click)="removeOwner(permission, owner.id)" matChipRemove>
                                            <mat-icon style="color:white;">cancel</mat-icon>
                                        </button>
                                    </mat-chip>
                                    }
                                    <mat-chip (click)="searchAddPrimaryUser([permission])"
                                        style="background-color:#0066B2">
                                        <mat-icon class="center-content" style="cursor:pointer;">add</mat-icon>
                                    </mat-chip>
                                </mat-chip-set>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="preapproved">

                            <th mat-header-cell *matHeaderCellDef>preapproved
                                <div>
                                    <input type="checkbox" (change)="$event ? masterTogglePreapproved() : null"
                                        [checked]="isAllPreapprovedSelected()"
                                        [indeterminate]="!isAllPreapprovedSelected()" />
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let permission">
                                <input type="checkbox" name="formcheckbox" (click)="$event.stopPropagation()"
                                    [checked]="permission.preapproved" (change)="togglePreapproved(permission)" />
                            </td>

                        </ng-container>

                        <ng-container matColumnDef="del">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element" style="text-align:center;">
                                <button mat-icon-button matSuffix (click)="deleteRow(element)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="selectedPermissionsDisplayedColumns;"></tr>
                        <tr mat-row *matRowDef="let row; columns: selectedPermissionsDisplayedColumns;"></tr>

                    </table>
                </form>
                }


                <mat-divider></mat-divider>

                <div class="btn-toolbar d-flex justify-content-center pt-4 pb-4" role="toolbar" *ngIf="!isLoading">
                    <mat-spinner [diameter]="30" *ngIf="isSubmitting"
                        style="display:inline-block; margin-left: 10px; top: 10px;"></mat-spinner>
                    <div class="btn-group mr-2" role="group"
                        *ngIf="hasWritePermissions() && !isSubmitting && clientApp !== undefined && submittedRequests.length == 0 && this.selection.selected.length > 0">
                        <button class="button" type="submit" (click)="submitRequest()">submit</button>
                    </div>
                    <div class="btn-group mr-2" role="group" *ngIf="!isSubmitting && clientApp != undefined">
                        <button class="button" type="button" (click)="resetForm()">reset</button>
                    </div>
                </div>


                <display-http-error [message]="submitErrorMessage.message"
                    [errors]="submitErrorMessage.errors"></display-http-error>
            </div>
        </div>
        <div class="row" *ngIf="submittedRequests.length > 0">
            <div class="col col-12">
                <a class="close-button" [routerLink]="['/applications/update-non-chevron-permissions']"><span
                        class="icon-remove close-button"></span></a>
                <h1>request submitted</h1>
                <display-http-error [message]="submitErrorMessage.message"
                    [errors]="submitErrorMessage.errors"></display-http-error>
                <display-requests [requests]="submittedRequests"></display-requests>
            </div>
        </div>}
        @else {
        <div class="row">
            <div class="col col-12">
                <h1>access denied</h1>
                <p style="text-align:center;color:red;">you do not have permission to access this page.</p>
            </div>
        </div>}
    </section>
</main>